import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { GatewayAPIService } from '../../core/gateway-api.service';
import { StorageService } from '../../core/storage/storageService';
import { MerchantService } from '../../models/merchant/merchantService';
import { ListItem } from '../../../../../../libs/Shared/components/model/listItem';
import { SignInResponse } from '../../models/users/signInResponse';
import { UserService } from '../../models/users/userService';
import { AdminService } from '../../models/admin/adminService';
import { RealtimeService } from '../../core/realtime/realtime';

@Component({
  selector: 'app-bootstrap-session',
  standalone: false,
  templateUrl: './bootstrap-session.component.html',
})
export class BootstrapSessionComponent {
  isLoading = true;

  constructor(
    private api: GatewayAPIService, 
    private storage: StorageService, 
    private router: Router, 
    private userService: UserService, 
    private merchantService: MerchantService, 
    private adminService: AdminService,
    private realtimeService: RealtimeService) {

    this.api.apiCallSane(
      "/auth/bootstrap",
      'POST',
      this.api.getDefaultHeaders(),
      null,
      null,
    ).then((response: any) => {
      this.handleBootstrapResponse(response);
    });
  }


  private async handleBootstrapResponse(response: SignInResponse) {

      if (response.user) {
 
          this.storage.clearSession();

          await this.userService.initializeSession(response);

          this.merchantService.syncStatements(this.storage.getMyAccount());

          this.adminService.getMerchantBrands().then((response: string[]) => {
              let brandList = response.map(s => new ListItem({id: s, name: s}));
              brandList.push(new ListItem({id: "New Brand", name: "New Brand"}));
              this.storage.setBrandList(brandList);
          });
          this.isLoading = false;

          // this.realtimeService.connect();

          if (this.storage.getSelectedLocation() || (response.user.originalRole == "portal.merchant")) {
              this.router.navigateByUrl("merchant/account");
          }
          else {
              this.router.navigateByUrl("dashboard");
          }        
  
      } 
      else {
          // this.isLoading = false;
          throw "Unable to sign in with provided credentials"
      }
   }
}